import styled from "@emotion/styled";
import { Button } from "react-aria-components";

/**
 * Bare 44px tap-target wrapper used as the press-to-open element inside a
 * `DialogTrigger`. Inherits text styling from the parent — flavor-specific
 * trigger buttons (`PopupDialogTriggerButton`, `CustomDialogTriggerButton`)
 * just re-export this base.
 */
export const DialogTriggerButton = styled(Button)`
  display: flex;
  height: 2.75rem /* 44/16 */;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
`;
